import React, { Component } from 'react';
import logoscritta from '../ext/images/laservideo_scritta.png';
import logoleone from '../ext/images/logo2.png';

export class Home extends Component {
    displayName = Home.name

    render() {
        return (
            <div>
                <div className="text-center img-scritta">
                    <img
                        alt="dd"
                        src={logoscritta}
                        width="50%"
                        height="50%"
                        className="d-inline-block align-top"
                    />
                </div>
                <div className="text-center img-logo">
                    <img
                        alt="dd"
                        src={logoleone}
                        width="35%"
                        height="35%"
                        className="d-inline-block align-top"
                    />
                </div>
            </div>
        );
    }
}
